.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg);
  padding: 32px 24px;
}

.card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 48px 52px;
  max-width: 780px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-sm);
}

.logoWrap {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  overflow: hidden;
  margin: 0 auto 22px;
}

.logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.title {
  font-family: 'Google Sans', sans-serif;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -.02em;
  color: var(--ink);
  margin-bottom: 10px;
}

.tagline {
  font-size: 15.5px;
  color: var(--muted);
  line-height: 1.6;
  margin-bottom: 26px;
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
}

/* Feature list */
.features {
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-align: left;
  margin-bottom: 28px;
}

.feature {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  font-size: 14px;
  line-height: 1.6;
}

.featureLead {
  font-weight: 600;
  color: var(--ink);
}

.featureDetail {
  color: var(--muted);
}

.featureIcon {
  font-size: 22px !important;
  color: var(--blue);
  flex-shrink: 0;
  margin-top: 1px;
}

.divider {
  border: none;
  border-top: 1px solid var(--border);
  margin: 0 0 24px;
}

/* Error badge */
.errorBadge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--red-lt);
  color: var(--red);
  border: 1px solid #f5c6c5;
  border-radius: 6px;
  padding: 11px 16px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: left;
}

/* Two-path layout */
.paths {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 24px;
}

/* Command block */
.block {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px 18px;
  text-align: left;
}

.blockLabel {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted2);
  text-transform: uppercase;
  letter-spacing: .08em;
  margin-bottom: 12px;
}

.step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}
.step:last-child { margin-bottom: 0; }

.stepNum {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--blue);
  color: white;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  font-family: 'Google Sans', sans-serif;
}

.stepText {
  font-size: 13px;
  color: var(--ink2);
  line-height: 1.55;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stepDetail {
  color: var(--muted);
  font-size: 12.5px;
}

.copyCmd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: white;
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: 4px 10px 4px 8px;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  text-align: left;
}

.copyCmd:hover {
  border-color: var(--blue);
  background: var(--blue-lt);
}

.copyCmd code {
  font-size: 12.5px;
  background: none;
  border: none;
  padding: 0;
  color: var(--ink);
  font-weight: 500;
}

.copyIcon {
  font-size: 14px !important;
  color: var(--muted2);
  transition: color .15s;
}

.copyCmd:hover .copyIcon { color: var(--blue); }

.footer {
  font-size: 12.5px;
  color: var(--muted);
  margin-top: 4px;
}
